import { rootApi } from "../../api/rootApi";

export const appUserMenuApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllMenuItems: builder.mutation({
        query: (params) => {
          return {
            method: "GET",
            url: "/admin/appMenu",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + params.token,
            },
          };
        },
      }),
    addMenuItemMaster: builder.mutation({
      query: (params) => {
        const formData = new FormData();
        formData.append("name", params.name);
        formData.append("action", params.action);
        formData.append("link", params.link);
        formData.append("order_at", params.order_at);
        formData.append("icon", params.icon);

        return {
          method: "POST",
          url: "/admin/appMenu/add",
          headers: {
            Authorization: "Bearer " + params.token,
          },
          body: formData,
        };
      },
    }),
    deleteMenuItemMaster: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/admin/appMenu/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
          },
        };
      },
    }),

    fetchAll: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: "/admin/appUserMenu",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
          },
        };
      },
    }),
    fetchAllTenant: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/admin/appUserMenu/${params.tenant_id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
          },
        };
      },
    }),
    addAppUserMenu: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: "/admin/appUserMenu/add",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + params.token,
          },
          body: params.data,
        };
      },
    }),
    updateAppUserMenu: builder.mutation({
      async queryFn(params, _api, _extraOptions, fetchWithBQ) {
        const commonRequest = {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
          },
          body: params.data,
        };

        const primaryResult = await fetchWithBQ({
          url: `/admin/appUserMenu/update/${params.id}`,
          ...commonRequest,
        });

        if (!primaryResult.error) {
          return { data: primaryResult.data };
        }

        const shouldRetryWithLegacyRoute =
          primaryResult.error?.status === 400 &&
          typeof primaryResult.error?.data?.message === "string" &&
          primaryResult.error.data.message.includes(
            "Please provide tenant's slug to connect.",
          );

        if (!shouldRetryWithLegacyRoute) {
          return { error: primaryResult.error };
        }

        const fallbackResult = await fetchWithBQ({
          url: `/admin/appUserMenu/${params.id}`,
          ...commonRequest,
        });

        if (!fallbackResult.error) {
          return { data: fallbackResult.data };
        }

        return { error: primaryResult.error };
      },
    }),
      deleteAppUserMenu: builder.mutation({
        query: (params) => {
          return {
            method: "DELETE",
            url: `/admin/appUserMenu/${params.id}`,
            headers: {
              "Content-Type": "application/json",
              authorization: "Bearer " + params.token,
            },
          };
        },
      }),
  }),
});
export const {
  useFetchAllMenuItemsMutation,
  useAddMenuItemMasterMutation,
  useDeleteMenuItemMasterMutation,
  useFetchAllMutation,
  useAddAppUserMenuMutation,
  useDeleteAppUserMenuMutation,
  useFetchAllTenantMutation,
  useUpdateAppUserMenuMutation,
} = appUserMenuApi;
